import { Box, Button, ModalProps, VStack } from "@chakra-ui/react";
import EtherAmount from "components/EtherAmount";
import HoneyIcon from "components/HoneyIcon";
import SimplePopup from "components/SimplePopup";
import WalletAsset from "components/WalletAsset";
import { honeyUniswapUrl } from "config";
import useAssets from "hooks/useAssets";
import useHive from "hooks/useHive";
import useTranslate from "hooks/useTranslate";
import useVesting from "hooks/useVesting";

type HoneyBalancePopupProps = Omit<ModalProps, "children">;

const HoneyBalancePopup = (props: HoneyBalancePopupProps) => {
  const translate = useTranslate();
  const { honeyBalance } = useAssets();
  const { vestingAmountInJarsRemainingSum } = useVesting();
  const { hiveBalanceInTokensSum } = useHive();

  return (
    <SimplePopup title={translate("honeyPopup:title")} size="sm" {...props}>
      <VStack spacing="2px" mt="6" px="3" pb="2">
        <WalletAsset
          icon={HoneyIcon}
          title={translate("honeyPopup:honeyInWallet:title")}
          value={<EtherAmount amount={honeyBalance} />}
        >
          <Box pr="3">
            <Button as="a" href={honeyUniswapUrl} size="xs" variant="outline">
              {translate("common:buy")}
            </Button>
          </Box>
        </WalletAsset>

        <WalletAsset
          icon={HoneyIcon}
          title={translate("honeyPopup:honeyInHive:title")}
          value={<EtherAmount amount={hiveBalanceInTokensSum} />}
        />

        <WalletAsset
          icon={HoneyIcon}
          title={translate("honeyPopup:honeyInJars:title")}
          value={<EtherAmount amount={vestingAmountInJarsRemainingSum} />}
        />
      </VStack>
    </SimplePopup>
  );
};

export default HoneyBalancePopup;
